import { useTranslation } from "react-i18next";

function Communication() {
  const { t } = useTranslation();

  return (
    <>
      <div className="content-page">
        <h3 className="process-title">
          {t("communication.communicationPreferences")}
        </h3>
        <div className="channel">
          <div className="channel-info">
            <div>
              <div className="channel-title">{t("communication.sms")}</div>
            </div>
            <div className="onoffswitch">
              <input
                type="checkbox"
                name="onoffswitch"
                className="onoffswitch-checkbox"
                id="myonoffswitchSMS"
              />
              <label
                className="onoffswitch-label"
                htmlFor="myonoffswitchSMS"
              ></label>
            </div>
          </div>
          <div className="channel-info">
            <div>
              <div className="channel-title">{t("communication.email")}</div>
            </div>
            <div className="onoffswitch">
              <input
                type="checkbox"
                name="onoffswitch"
                className="onoffswitch-checkbox"
                id="myonoffswitchEposta"
              />
              <label
                className="onoffswitch-label"
                htmlFor="myonoffswitchEposta"
              ></label>
            </div>
          </div>
          <div className="channel-info">
            <div>
              <div className="channel-title">{t("communication.phone")}</div>
            </div>
            <div className="onoffswitch">
              <input
                type="checkbox"
                name="onoffswitch"
                className="onoffswitch-checkbox"
                id="myonoffswitchPhone"
              />
              <label
                className="onoffswitch-label"
                htmlFor="myonoffswitchPhone"
              ></label>
            </div>
          </div>
          <div className="channel-info">
            <div>
              <div className="channel-title">{t("communication.whatsapp")}</div>
            </div>
            <div className="onoffswitch">
              <input
                type="checkbox"
                name="onoffswitch"
                className="onoffswitch-checkbox"
                id="myonoffswitchWp"
              />
              <label
                className="onoffswitch-label"
                htmlFor="myonoffswitchWp"
              ></label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Communication;
